module.exports = __webpack_public_path__ + "img/noti_sample.c66881f8.png";